/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback } from 'react';
import { isEqual } from 'lodash-es';

export const useSortableData = (items) => {
  const [sortConfig, setSortConfig] = useState(null);
  const [itemsToSave, setItemsToSave] = useState(() => items);

  useEffect(() => {
    if (!isEqual(items, itemsToSave)) {
      setItemsToSave(items);
    }

    if (items?.length === 0) setSortConfig(null);
  }, [items]);

  let sortedItems = [...itemsToSave];

  if (sortConfig !== null) {
    sortedItems.sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  }

  const requestSort = useCallback(
    (key) => {
      let direction = 'ascending';
      if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
        direction = 'descending';
      }
      setSortConfig({ key, direction });
    },
    [sortConfig?.key, sortConfig?.direction],
  );

  const getClassNamesFor = useCallback(
    (name) => {
      if (!sortConfig) return;
      return sortConfig.key === name ? sortConfig.direction : undefined;
    },
    [sortConfig?.key, sortConfig?.direction],
  );

  return {
    items: sortedItems,
    requestSort,
    getClassNamesFor,
  };
};
